export var ErrorPolicy;
(function (ErrorPolicy) {
    ErrorPolicy["ERROR_POLICY_FAIL"] = "fail";
    ErrorPolicy["ERROR_POLICY_SKIP"] = "skip";
})(ErrorPolicy || (ErrorPolicy = {}));
